import { useState } from "react"
import CRUDList from "../../components/CRUDList"
import Modal from "../../components/Modal"
import DeliveryServiceSelectionList from "../DeliveryServiceSelectionList"
import ServiceProviderDetails from "../../components/ServiceProviderDetails"

import { alphabeticalSort } from "../../utils/stringUtils"

/**
 * A picker to select delivery services to be plugged into a catalog at checkout
 * Selection occurs in a modal that displays a ProductSelectionList
 * 
 */
const DeliveryServicePluginPicker = ({
    title="Delivery",
    location={},
    selectedDeliveryCatalogsById={}, 
    onChange=()=>{}
}) => {
    const [createModalOpen, setCreateModalOpen] = useState(false)
    //called when items are added / removed via the PayeeProductSelectionList
    const handleChangeSelection = (selectedIdMap={}) => {
        onChange({...selectedIdMap})
    }
    const handleDelete = id => {
        const map = {...selectedDeliveryCatalogsById}
        delete map[id]
        onChange(map)
    }
    const {settlementId="", city=""} = location || {}
    return (
        <div>
            <CRUDList 
                title={title}
                placeholder={<div className="display-flex justify-content-center padding-1em background-color-light-grey border-radius-8px font-size-16px">No delivery service selected</div>}
                createIcon="directions-car"
                createLabel="Change"
                objectsById={selectedDeliveryCatalogsById}
                showDefaultRadioButton={false}
                defaultObjectId={""}
                showEditMenuItem={false}
                showDeleteMenuItem={true}
                showActionMenu={true}
                renderItem={
                    deliveryCatalog => <div>
                                            <ServiceProviderDetails 
                                                imageUrl={deliveryCatalog.payeeLogoImageUrl} 
                                                name={deliveryCatalog.payeeName}
                                                details={deliveryCatalog.name}
                                            />
                                        </div>
                }
                renderItemContainerClassName="card margin-bottom-05em padding-5px"
                sortFunction={(oA, oB) => alphabeticalSort(oA.payeeName, oB.payeeName)}
                handleClickAddButton={() => setCreateModalOpen(true)}
                handleClickDeleteMenuItem={handleDelete}
            />
            {
                createModalOpen ?
                <Modal
                    isOpen={Boolean(createModalOpen)}
                    closeModal={() => setCreateModalOpen(false)}
                    showCloseButton={true}
                    className="height-fit-content max-height-100pct"
                    overlayClassName="flex-center padding-1pct"
                    innerClassName=""
                    closeOnOverlayClick={true}
                >
                    <div className="display-width-400px">
                    <DeliveryServiceSelectionList 
                        settlementId={settlementId}
                        city={city}
                        selectedIdMap={selectedDeliveryCatalogsById}
                        onSubmit={selectedIdMap => {
                                handleChangeSelection(selectedIdMap)
                                setCreateModalOpen(false)
                            }
                        }
                    />
                    </div>
                </Modal>
                :
                null
            }
        </div>
    )
}


export default DeliveryServicePluginPicker